import { atom } from 'jotai';

/** Unseen Revive (CRM lead) ids — GET /idp/notifications `reviveIds`. */
export const idpNotificationAtom = atom<string[]>([]);
/** New Reveal (identified-shopper) sessions since the user's seen date — `revealCount`; 0 when unknown. */
export const idpRevealCountAtom = atom<number>(0);
/**
 * Stored Reveal seen date (yyyyMMdd) from GET /idp/notifications `revealSeenDate` (VMS1-6492);
 * null when the API did not send one.
 */
export const idpRevealSeenDateAtom = atom<string | null>(null);
